import { ArrowsDownUp, X } from '@phosphor-icons/react';
import { css, cx } from '@eti/styles';
import { breakpoints, vars } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import DotPulseLoader from './assets/DotPulseLoader';

const buttonStyles = css`
  align-items: center;
  align-self: center;
  background-color: transparent;
  border: none;
  bottom: 0;
  cursor: pointer;
  display: flex;
  inset-inline-end: 0.125rem;
  padding: 0.75rem;
  position: absolute;
  top: 0;
  z-index: 1;

  &:focus-visible {
    outline: 0.125rem solid ${vars.colors.focusRing};
  }
`;

const iconLoader = css`
  align-content: center;
  bottom: 0;
  inset-inline-end: 0;
  margin-inline-end: 0.75rem;
  position: absolute;
  top: 0;
  z-index: 1;

  @media (min-width: ${breakpoints._970}) {
    margin-inline-end: 0.625rem;
  }
`;

const hiddenInWiderViewport = css`
  @media (min-width: ${breakpoints._768}) {
    display: none;
  }
`;

const arrowsDownUp = css`
  color: ${vars.colors.text.secondary};
`;

interface LocationComboboxSuffixProps {
  isFocused: boolean;
  isLoading: boolean;
  isNameEmpty: boolean;
  isOrigin: boolean;
  isSearchTermEmpty: boolean;
  onClearInput: () => void;
  onSwitchDirection?: () => void;
}

const LocationComboboxSuffix = ({
  isFocused,
  isLoading,
  isSearchTermEmpty,
  isNameEmpty,
  isOrigin,
  onClearInput,
  onSwitchDirection,
}: LocationComboboxSuffixProps) => {
  const { t } = useTranslation();
  return (
    <>
      {isLoading && (
        <div className={iconLoader} data-testid="locationComboboxSuffix-loading-indicator">
          <DotPulseLoader />
        </div>
      )}
      {!isLoading && isFocused && (!isSearchTermEmpty || !isNameEmpty) && (
        <button
          aria-label={t('ScreenReader.SearchForm.ClearInput')}
          className={buttonStyles}
          data-testid="locationComboboxSuffix-clear-button"
          onClick={onClearInput}
          type="button"
        >
          <X aria-hidden size="1.25rem" weight="light" />
        </button>
      )}
      {!isLoading && !isFocused && isOrigin && (
        <button
          aria-label={t('Air.Search.SwitchLocations.Label')}
          className={cx(buttonStyles, hiddenInWiderViewport)}
          data-testid="locationComboboxSuffix-switch-direction-button"
          onClick={onSwitchDirection}
          type="button"
        >
          <ArrowsDownUp aria-hidden className={arrowsDownUp} size="1.25rem" weight="light" />
        </button>
      )}
    </>
  );
};

export default LocationComboboxSuffix;
